const secondary = {
    social_bind_with: '绑定到已有账户? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登录并绑定。',
};
export default Object.freeze(secondary);
